import { Component, Input } from '@angular/core';
import { NoodleQuestionDto } from '../../common/general-types/noodle.dto';

@Component({
  selector: 'app-noodle-question-basic',
  standalone: true,
  imports: [],
  templateUrl: './noodle-question-basic.component.html',
  styleUrl: './noodle-question-basic.component.css'
})
export class NoodleQuestionBasicComponent {

  @Input() question!: NoodleQuestionDto;

}
